import { useRoleQuery } from './useRoleQuery';
import { useRolesQuery } from './useRolesQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface UpdateRoleMutationParams {
  id: string;
  name?: string;
  description?: string;
  permissions?: string[];
}

export const useUpdateRoleMutation = createMutationHook(
  'settings.teamPermissions.updateRole',
  (params: UpdateRoleMutationParams) => ({
    coreRoleUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          description: params.description,
          permissions: params.permissions,
        },
      },
      id: true,
      name: true,
      permissions: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
  {
    invalidateQueries: [useRoleQuery, useRolesQuery],
  },
);
